import {
    FetchState,
    HsabInvestmentIframe,
    HsabInvestmentAccountStatus,
    HsabLegacyInvestmentProvider
} from "@/shared/types";
import * as bankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { templatedFetchKeyStore } from "@/shared/store/fetchKeyedPlugin";


const useIframeSubStore = defineStore("hsabInvestments_iframe", () => {
    const getEmptyIframe = () => ({ url: null });
    return templatedFetchKeyStore<HsabInvestmentIframe>(
        getEmptyIframe,
        null,
        bankService.getHsabIframe
    );
});

const useAccountStatusSubStore = defineStore("hsabInvestments_accountStatus", () => {
    const getEmptyAccountStatus = () => ({
        investmentEnabled: null, investmentAccounts: null, investmentBalance: null
    });

    return templatedFetchKeyStore<HsabInvestmentAccountStatus>(
        getEmptyAccountStatus,
        null,
        bankService.getHsabInvestmentAccountStatus
    );
});

export const useHsabInvestmentStore = defineStore("hsabInvestment", {
    getters: {
        investmentAccountStatus () {
            return useAccountStatusSubStore();
        },
        investmentAccountStatusLoaded: () => useAccountStatusSubStore().fetchState === FetchState.Loaded,
        iframeLoaded: () => useIframeSubStore().fetchState === FetchState.Loaded,
        iframeUrl: () => useIframeSubStore().url,
        hsabInvestmentsEnabled: () => useAccountStatusSubStore().investmentEnabled,
        hsabInvestmentBalance: () => useAccountStatusSubStore().investmentBalance,
        hsabInvestmentAccounts: () => useAccountStatusSubStore().investmentAccounts,
        hasDevenirAccount (): boolean {
            const hasDevinerAccount = _.find(this.investmentAccountStatus.investmentAccounts,
                x => x.accountName.toLowerCase() === HsabLegacyInvestmentProvider.Devenir);
            return !!hasDevinerAccount;
        },
        hasSchwabAccount (): boolean {
            const hasSchwabAccount = _.find(this.investmentAccountStatus.investmentAccounts,
                x => x.accountName.toLowerCase() === HsabLegacyInvestmentProvider.Schwab);

            return !!hasSchwabAccount;
        },
        hasLegacyInvestmentAccount (): boolean {
            return this.hasSchwabAccount || this.hasDevenirAccount;
        }
    },
    actions: {
        async loadInvestmentAccountStatus (options: {
            username?: string,
            partnerId?: number
        }): Promise<any> {
            return useAccountStatusSubStore().fetchKeyedApiCall(options)
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
        async loadInvestmentIframe (options?: {
            username?: string,
            partnerId?: number
        }): Promise<any> {
            return useIframeSubStore().fetchKeyedApiCall(options, true)
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
    }
});